import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { LoadingOutlined } from '@ant-design/icons';
import { Button, Spin, message } from 'antd';
import './EmailConfirmation.scss';
import logo from '../../assets/images/CooperLogo.png';
import {
  put, ResponseWrapper, RequestWrapper, isSuperAgentError,
} from '../../dataSource/requests';
import { SessionExpiredException } from '../../utils/errors';

const EmailConfirmation = (): JSX.Element => {
  const [codeResponse, setCodeResponse] = useState(0);
  const { token: tokenParam } = useParams();
  const navigate = useNavigate();
  let mensagemResposta;
  let button;
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  switch (codeResponse) {
    case 0:
      mensagemResposta = <div><Spin indicator={antIcon} /></div>;
      break;

    case 1004:
      mensagemResposta = (
        <div>
          <p>
            <strong>E-mail confirmado com sucesso!</strong>
          </p>
          <p>Agora você já pode fazer o login no aplicativo.</p>
        </div>
      );

      button = <Link to="/"><Button type="primary">FAZER LOGIN</Button></Link>;
      break;

    case -1004:
    default:
      mensagemResposta = <div><p><strong>Token inválido!</strong></p></div>;
      button = <Link to="/"><Button type="primary">FAZER LOGIN</Button></Link>;
      break;
  }

  useEffect(() => {
    const checkEmail = async (): Promise<void> => {
      let response: ResponseWrapper;
      let responseError: ResponseWrapper | undefined;
      let genericError: Error | undefined;

      const requestReference: RequestWrapper = put({
        url: `/auth/customer/emailConfirmation/${tokenParam}`,

        frontConfigs: {
          navigateFunction: navigate,
        },

        noAuth: true,
      });

      try {
        response = await requestReference;
      } catch (error) {
        if (isSuperAgentError(error)) {
          responseError = error.response;
        } else {
          genericError = error as Error;
        }

        if (!(error instanceof SessionExpiredException)) {
          message.error('Ocorreu um erro ao confirmar o email, tente novamente');
        }

        return;
      }

      setCodeResponse(response.body.code);
    };

    checkEmail();
  }, []);

  return (
    <div className="container">
      <div className="box">
        <img className="logo-image" src={logo} alt="" />
        <div className="message">
          {mensagemResposta}
        </div>
        {button}
      </div>
    </div>
  );
};

EmailConfirmation.propTypes = {};

EmailConfirmation.defaultProps = {};

export default EmailConfirmation;
